/**
 * Eventos do Sistema de Ciclo de Vida
 * Equivalente aos eventos do Flutter
 */

// Eventos base
export abstract class AppLifecycleEvent {
  readonly timestamp = new Date();
}

// Eventos de conectividade
export class ConnectivityRestoredEvent extends AppLifecycleEvent {
  constructor(public readonly restoredAt: Date = new Date()) {
    super();
  }
}

export class ConnectivityLostEvent extends AppLifecycleEvent {
  constructor(public readonly lostAt: Date = new Date()) {
    super();
  }
}

// Eventos de performance
export class PerformanceDegradedEvent extends AppLifecycleEvent {
  constructor(
    public readonly frameDropCount: number,
    public readonly detectedAt: Date = new Date()
  ) {
    super();
  }
}

export class AppFreezeDetectedEvent extends AppLifecycleEvent {
  constructor(
    public readonly detectedAt: Date,
    public readonly freezeDuration: number
  ) {
    super();
  }
}

// Eventos de memória
export class MemoryPressureEvent extends AppLifecycleEvent {
  constructor(
    public readonly consecutiveWarnings: number,
    public readonly detectedAt: Date = new Date()
  ) {
    super();
  }
}

export class MemoryDecayEvent extends AppLifecycleEvent {
  constructor(
    public readonly metricName: string,
    public readonly previousValue: number,
    public readonly newValue: number,
    public readonly decayedAt: Date = new Date()
  ) {
    super();
  }
}

export class BackgroundCleanupEvent extends AppLifecycleEvent {
  constructor(
    public readonly reason: string,
    public readonly cleanupAt: Date = new Date()
  ) {
    super();
  }
}

// Eventos de sessão
export class SessionTimeoutEvent extends AppLifecycleEvent {
  constructor(
    public readonly inactivityDuration: number,
    public readonly timeoutAt: Date = new Date()
  ) {
    super();
  }
}

export class ExternalUrlReturnEvent extends AppLifecycleEvent {
  constructor(
    public readonly externalDuration: number,
    public readonly returnedAt: Date = new Date()
  ) {
    super();
  }
}

// Eventos de foco de janela
export class WindowFocusGainedEvent extends AppLifecycleEvent {
  constructor(
    public readonly windowId: string | null = null,
    public readonly gainedAt: Date = new Date()
  ) {
    super();
  }
}

export class WindowFocusLostEvent extends AppLifecycleEvent {
  constructor(
    public readonly windowId: string | null = null,
    public readonly lostAt: Date = new Date()
  ) {
    super();
  }
}

// Estados de ciclo de vida
export enum AppLifecycleState {
  RESUMED = 'resumed',
  PAUSED = 'paused',
  INACTIVE = 'inactive',
  DETACHED = 'detached',
  HIDDEN = 'hidden'
}

export class LifecycleStateChangedEvent extends AppLifecycleEvent {
  constructor(
    public readonly previousState: AppLifecycleState,
    public readonly newState: AppLifecycleState,
    public readonly changedAt: Date = new Date()
  ) {
    super();
  }
}
